export function reduce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return state + 1;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/dnd-core/dist/esm/reducers/stateId.js
// module id = 1848
// module chunks = 0